import React from 'react';

import { CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useGetFavoriteCodesQuery } from 'src/common/apis/CommonApi';
import SavedCodeCellFlorence from 'src/common/components/UserCodesContainer/components/SavedCodeCellFlorence';
import { useAppSelector } from 'src/common/hooks/reduxHooks';
import { SavedCode } from 'src/common/types/Codes';

import { ReactComponent as NoResultsIcon } from '../../../../common/assets/icons/no_results_icon.svg';

const MyFavoriteCodes: React.FC = () => {
  const { user } = useAppSelector((state) => state.model);

  const { data, isLoading } = useGetFavoriteCodesQuery(undefined, {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: 60,
  });

  if (!user?.activeSubscriptionType && !user?.organizationId) {
    return (
      <Typography color='text.secondary' textAlign='center' mt='56px'>
        To view your Favorite Codes you must have an active subscription or be a
        member of an organization.
      </Typography>
    );
  }

  if (!isLoading && data?.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '56px',
        }}
      >
        <NoResultsIcon />
        <Typography color='text.secondary' textAlign='center' mt='16px'>
          No Favorite Codes were saved yet.
        </Typography>
      </Box>
    );
  }

  if (isLoading) {
    return <CircularProgress color='primary' size='32px' />;
  }

  return (
    <>
      {data?.map((code: SavedCode) => (
        <SavedCodeCellFlorence key={code.id} code={code} />
      ))}
    </>
  );
};

export default MyFavoriteCodes;
